export default "__VITE_PUBLIC_ASSET__d5782923__"